import { useToken } from "@gluestack-style/react";
import { SiteSelect } from "components/form/SiteSelect";
import { Box, Button, HStack, Typography } from "components/ui";
import SwitchFilter from "components/ui/SwitchFilter";
import CheckBox from "expo-checkbox";
import React from "react";
import { Col, Container as GridContainer, Row } from "react-native-flex-grid";
import { useIsMobile } from "utils/hooks/useIsMobile";

type Props = {
	onHasReadChange: (hasRead: boolean | undefined) => void;
	onSiteChange: (site: any) => void;
};

const NotificationFilter = ({ onHasReadChange, onSiteChange }: Props) => {
	const isMobile = useIsMobile();
	const [showUnReadMessages, setShowUnReadMessages] = React.useState(false);
	const resolvedPrimarylight = useToken("colors", "primarylight");

	const handleHasReadChange = (showUnReadMessages: boolean) => {
		setShowUnReadMessages(showUnReadMessages);
		if (showUnReadMessages) {
			onHasReadChange(false);
		} else {
			onHasReadChange(undefined);
		}
	};

	const handleSiteChange = (site: any) => {
		onSiteChange(site);
	};

	if (isMobile) {
		return (
			<Box my={24} gap={12}>
				<Box minWidth={350}>
					<SiteSelect isLight onSelect={handleSiteChange} />
				</Box>

				<SwitchFilter text="Is core?" toolTip="Priority stock items" value={showUnReadMessages} onChange={handleHasReadChange} />
			</Box>
		);
	}
	return (
		<Box>
			<HStack gap={24}>
				<Box minWidth={350}>
					<SiteSelect isLight onSelect={handleSiteChange} />
				</Box>
				<Button onPress={() => handleHasReadChange(!showUnReadMessages)} justifyContent="flex-start" paddingHorizontal={0} gap={4} alignItems="center" marginTop={0} marginBottom={0}>
					<CheckBox color={"#2B6FBB"} value={showUnReadMessages} />
					<Typography>Show unread messages only</Typography>
				</Button>
			</HStack>
		</Box>
	);
};

export default NotificationFilter;
